@file:OptIn(InternalResourceApi::class)

package imobly.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/imobly.composeapp.generated.resources/"

internal val Res.font.Montserrat_Italic_VariableFont_wght: FontResource by lazy {
      FontResource("font:Montserrat_Italic_VariableFont_wght", setOf(
        ResourceItem(setOf(), "${MD}font/Montserrat-Italic-VariableFont_wght.ttf", -1, -1),
      ))
    }

internal val Res.font.Montserrat_VariableFont_wght: FontResource by lazy {
      FontResource("font:Montserrat_VariableFont_wght", setOf(
        ResourceItem(setOf(), "${MD}font/Montserrat-VariableFont_wght.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("Montserrat_Italic_VariableFont_wght", Res.font.Montserrat_Italic_VariableFont_wght)
  map.put("Montserrat_VariableFont_wght", Res.font.Montserrat_VariableFont_wght)
}
